module.exports = __webpack_public_path__ + "media/application/images/home/home-background@2x-9937b4cc4886e780ed6c6243975318dd.jpg";